import CheckBox from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import { StateAbbreviation } from "encamp-shared/src/constants/states";
import { getStorageTypeDropdownOptionsForState } from "encamp-shared/src/constants/tierii";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { FacilityChemicalStorageLocationInput } from "generated-graphql/graphql";
import React from "react";
import { Control, Controller } from "react-hook-form";

type Props = {
  control: Control<FacilityChemicalStorageLocationInput>;
  disabled?: boolean;
  /**
   * Called synchronously whenever the selected types change, so the caller can
   * keep the legacy scalar `storageType` in sync with `storageTypes[0]`.
   */
  onTypesChange?: (types: string[]) => void;
};

export const StorageTypeMultiSelect: React.FC<Props> = ({ control, disabled, onTypesChange }) => {
  const options = getStorageTypeDropdownOptionsForState("CA" as StateAbbreviation).map(
    (st) => st.label
  );

  return (
    <Controller
      name="storageTypes"
      control={control}
      render={({ field, fieldState }) => {
        const selected = Array.isArray(field.value) ? field.value : [];
        return (
          <Autocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selected}
            onChange={(_, val) => {
              field.onChange(val);
              onTypesChange?.(val);
            }}
            disabled={disabled}
            getOptionLabel={(option) => prettyPrintEnumValue(option)}
            renderOption={(props, option, { selected: isSelected }) => (
              <li {...props} key={option}>
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                  checkedIcon={<CheckBox fontSize="small" />}
                  checked={isSelected}
                />
                {prettyPrintEnumValue(option)}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Storage Types"
                required={selected.length === 0}
                error={!!fieldState.error}
              />
            )}
          />
        );
      }}
    />
  );
};
